import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import constants from "../../../assets/constants.js";
import EmpireProcessMapListItem from "../../ui/empireProcessMapListItem.js";
import Widget from "../../ui/widget.js";
import WidgetList from "../../ui/widgetList.js";
import WidgetSkeleton from "../../ui/widgetSkeleton.js";
import WidgetTitle from "../../ui/widgetTitle.js";

const EmpireProcessMaps = props => {
  const { userODM } = props;

  const [titleText, setTitleText] = useState(null);
  const [workflowODMs, setWorkflowODMs] = useState([]);

  useEffect(() => {
    if (userODM != null) {
      let theReturn = [];
      if (userODM.omniData.businessPillar === constants.empirePillarEnumes.personnel) {
        theReturn.push({
          omniData: {
            primaryTitle: "Hiring Process",
            secondaryTitle: "The procedure for hiring a new employee for your department.",
            businessPillar: constants.empirePillarEnumes.personnel,
            urlLink: `https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/job-hiring-flowchart.pdf`,
          },
        });
        theReturn.push({
          omniData: {
            primaryTitle: "Job Onboard Training",
            secondaryTitle: "Training and onboarding new employees.",
            businessPillar: constants.empirePillarEnumes.personnel,
            urlLink: `https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/job-onboarding-training.pdf`,
          },
        });
      } else if (userODM.omniData.businessPillar === constants.empirePillarEnumes.marketing) {
        theReturn.push({
          omniData: {
            primaryTitle: "Taking a customer order.",
            secondaryTitle: "Detailed intructions for taking orders over the phone.",
            businessPillar: constants.empirePillarEnumes.marketing,
            urlLink: `https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/order-flowchart.pdf`,
          },
        });
        theReturn.push({
          omniData: {
            primaryTitle: "Sales Quote processing",
            secondaryTitle: "How to handle a customer sales quote response.",
            businessPillar: constants.empirePillarEnumes.marketing,
            urlLink: `https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/sales-flowchart.pdf`,
          },
        });
      } else if (userODM.omniData.businessPillar === constants.empirePillarEnumes.leadership) {
        theReturn.push({
          omniData: {
            primaryTitle: "Business Process Mapping",
            secondaryTitle: "How to create a Business Process Map.",
            businessPillar: constants.empirePillarEnumes.leadership,
            urlLink: `https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/Leadership_steps-to-create-a-business-process-map.png`,
          },
        });
        theReturn.push({
          omniData: {
            primaryTitle: "Suggestion Box SIPOC",
            secondaryTitle: "A SIPOC example illustrating a ideas from a suggestion box.",
            businessPillar: constants.empirePillarEnumes.leadership,
            urlLink: `https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/Leadership_sipoc_example1.png`,
          },
        });
      } else if (userODM.omniData.businessPillar === constants.empirePillarEnumes.finance) {
        theReturn.push({
          omniData: {
            primaryTitle: "Financial reporting cycle",
            secondaryTitle: "How our financial reporting for the cycle is generated.",
            businessPillar: constants.empirePillarEnumes.finance,
            urlLink: `https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/Financial+Reporting+Cycle.pdf`,
          },
        });
        theReturn.push({
          omniData: {
            primaryTitle: "Cash flow statement",
            secondaryTitle: "How to do prepare a Cash Flow Statement.",
            businessPillar: constants.empirePillarEnumes.finance,
            urlLink: `https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/Finance_PreparingStatementofCashFlow.png`,
          },
        });
      } else if (userODM.omniData.businessPillar === constants.empirePillarEnumes.opertations) {
        theReturn.push({
          omniData: {
            primaryTitle: "Website modification process",
            secondaryTitle: "How to process website design changes.",
            businessPillar: constants.empirePillarEnumes.opertations,
            urlLink: `https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/Operations_Websitechangeprocess.png`,
          },
        });
        theReturn.push({
          omniData: {
            primaryTitle: "Process change workflow",
            secondaryTitle: "How we approach changes to established processs.",
            businessPillar: constants.empirePillarEnumes.opertations,
            urlLink: `https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/Operations_ProcessChangeFlowchart.webp`,
          },
        });
      }
      setWorkflowODMs(theReturn);
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userODM]);

  useEffect(() => {
    if (workflowODMs != null) {
      setTitleText(`${workflowODMs.length} Map${workflowODMs.length === 1 ? "" : "s"} `);
    } else {
      setTitleText("Loading...");
      props.loadCommunicationTemplatesRequest();
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflowODMs]);

  return (
    <Widget>
      <WidgetTitle title={"Processes"} text={titleText}></WidgetTitle>

      {workflowODMs == null && <WidgetSkeleton />}
      {workflowODMs != null && (
        <WidgetList>
          {workflowODMs.map((theProcess, index) => {
            return (
              <EmpireProcessMapListItem
                key={`EmpireProcessMaps-${index}`}
                proccessMapODM={theProcess}
              />
            );
          })}
        </WidgetList>
      )}
    </Widget>
  );
};
const mapStateToProps = state => ({
  userODM: state.userSession.userODM,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EmpireProcessMaps));
